var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,10.1c0-0.1,0.1-0.3,0.2-0.4c0.2-0.2,0.5-0.2,0.7,0l3,3l3-3c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7 l-3.3,3.3c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.3-0.1-0.4-0.2l-3.3-3.3C4.2,10.4,4.2,10.2,4.2,10.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8,5.9c0,0.1-0.1,0.3-0.2,0.4c-0.2,0.2-0.5,0.2-0.7,0l-3-3l-3,3c-0.2,0.2-0.5,0.2-0.7,0 c-0.2-0.2-0.2-0.5,0-0.7l3.3-3.3C7.7,2.1,7.9,2.1,8,2.1s0.3,0.1,0.4,0.2l3.3,3.3C11.8,5.6,11.8,5.8,11.8,5.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort-arrow.a5077f85dcf2c59045f354494904cd3f.svg";
export { ForwardRef as ReactComponent };